import styled from "@emotion/styled";
import ExploreTokenPriceChart from "@screens/ExploreToken/ExploreTokenPriceChart";
import ExploreTokenPriceStatistics from "@screens/ExploreToken/ExploreTokenPriceStatistics";
import useWindowSize from "@src/hooks/useWindowSize";
import SizedBox from "@components/SizedBox";
import { Column, Row } from "@components/Flex";
import Text from "@components/Text";
import BN from "@src/utils/BN";
import { useExploreTokenVM } from "@screens/ExploreToken/ExploreTokenVm";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@src/constants";

const Root = styled(Column)`
  width: 100%;
  align-items: flex-end;

  & > :first-of-type {
    margin-bottom: 24px;
  }

  @media (min-width: 880px) {
    flex-direction: row;
    & > :first-of-type {
      margin-bottom: 0;
      margin-right: 24px;
    }
  }
`;

const StatsItem = styled(Column)`
  margin-right: 24px;
  margin-bottom: 8px;
  @media (min-width: 880px) {
    margin-right: 32px;
  }
  &:last-of-type {
    margin-right: 0;
  }
`;

const TokenStatsCol = styled(Column)`
  max-width: 100%;

  @media (min-width: 880px) {
    max-width: 550px;
  }
`;

const ExploreTokenBasicInformation = () => {
  const { width } = useWindowSize();
  const vm = useExploreTokenVM();
  if (vm.statistics == null) return <Navigate to={ROUTES.ROOT} />;
  const statistics = [
    {
      title: "Collateral factor",
      value: vm.statistics?.cf.times(100).toFormat(2) + " %"
    },
    {
      title: "Liquidation threshold",
      value: vm.statistics?.lt.times(100).toFormat(2) + " %"
    },
    {
      title: "Liquidation penalty",
      value: vm.statistics?.penalty.times(100).toFormat(2) + " %"
    },
    {
      title: "Max supply",
      value: vm.statistics?.supplyLimit.gt(0)
        ? "$" + vm.statistics?.supplyLimit
        : "No limit"
    }
  ];

  return width && width >= 0 ? (
    <Root>
      <Column crossAxisSize="max">
        <>
          <Row alignItems="end" mainAxisSize="fit-content">
            {statistics.map((s, i) => (
              <StatsItem key={i}>
                <Text size="medium" type="secondary">
                  {s.title}
                </Text>
                <Text>{s.value}</Text>
              </StatsItem>
            ))}
          </Row>

          <SizedBox height={50} />

          <TokenStatsCol crossAxisSize="max">
            <ExploreTokenPriceStatistics />
            <SizedBox height={50} />
          </TokenStatsCol>
        </>
      </Column>
    </Root>
  ) : (
    <Root>
      <Row style={{ flexWrap: "wrap" }}>
        {statistics.map((s, i) => (
          <StatsItem key={i}>
            <Text size="medium" type="secondary">
              {s.title}
            </Text>
            <Text>{s.value}</Text>
          </StatsItem>
        ))}
      </Row>
      <TokenStatsCol crossAxisSize="max">
        <ExploreTokenPriceChart />
        <SizedBox height={24} />
        <ExploreTokenPriceStatistics />
      </TokenStatsCol>
      <SizedBox height={50} />
    </Root>
  );
};
export default ExploreTokenBasicInformation;
